import { react2angular } from 'react2angular';
import { compose } from 'redux';
import app from '../../../browser/addform/scripts/app';
import { withProvider } from '../../redux';
import { withContext } from '../../utils/hoc/withContext';
import { RosreestrDataContainer } from './RosreestrData.container';

app.component(
  'cianAfRosreestrData',
  react2angular(compose(withContext, withProvider)(RosreestrDataContainer), [], ['config']),
);
